import {Component, OnInit} from '@angular/core';
import {ModalController, NavParams} from "@ionic/angular";
import {Clipboard} from '@capacitor/clipboard';
import {TranslocoService} from "@jsverse/transloco";

@Component({
    selector: 'app-loyalty-program-info',
    templateUrl: './loyalty-program-info.component.html',
    styleUrls: ['./loyalty-program-info.component.scss'],
})
export class LoyaltyProgramInfoComponent implements OnInit {

    public type: string = '';
    public refUrl: string = '';
    lang = 'uk';

    public buttonLabel: string = this.translocoService.translate('loyaltyProgramInfo.referralBtnLink');

    constructor(private modalCtrl: ModalController,
                private navParams: NavParams,
                private translocoService: TranslocoService
    ) {
        this.translocoService.langChanges$.subscribe(language => {
            this.lang = language;
        })
    }


    ngOnInit() {
        this.type = this.navParams.data['type'];
        this.refUrl = this.navParams.data['refUrl'];
    }

    async copyUrl() {
        try {
            await Clipboard.write({
                string: this.refUrl
            });

            this.buttonLabel = this.translocoService.translate('loyaltyProgramInfo.copied');

            setTimeout(() => {
                this.buttonLabel = this.translocoService.translate('loyaltyProgramInfo.referralBtnLink');
            }, 1000);


        } catch (error) {
            console.error('Error copying URL to clipboard:', error);
        }
    }

    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

}
